import { useGlobalStore } from '@shared/store';
import { commonApi } from '../../apis';

// 初始化企业授权 appId、authCorpId 等参数信息
export const initCorpAuthInfo = async () => {
  try {
    const globalStore = useGlobalStore();
    const { currentCorpId, agentId } = globalStore.appData;

    const { ret, retdata } = await commonApi.getCorpAuthInfo<any, any>({
      currentCorpId,
      agentId,
    });

    ret === 0 && globalStore.setAppData(retdata);
  } catch (error) {
    console.log('初始化企业授权信息错误：', error);
  }
};
